import React from 'react';
import classnames from 'classnames';
import Modal from '@/page/subscription/new/components/modal';
import { getIncomeSource } from '@/utils/vip';
import * as native from '@/utils/native';
import { useLocaleStore } from '@/i18n/localeStore';

import styles from './index.module.css';

const WECHAT_CANCEL_GUIDE_URL = 'https://mp.weixin.qq.com/s/1RQfGzdZ7Kkrsh5eI6FEiQ';

export type ServiceNoticeModalVariant = 'renewal' | 'consumable';

export interface ServiceNoticeModalProps {
  visible: boolean;
  onClose: () => void;
  variant?: ServiceNoticeModalVariant;
}

const ServiceNoticeModal: React.FC<ServiceNoticeModalProps> = ({
  visible,
  onClose,
  variant = 'renewal',
}) => {
  const { $t } = useLocaleStore();
  const handleJump = (jumpUrl: string) => {
    if (getIncomeSource() === 'MTXX-WEB') {
      window.open(jumpUrl);
    } else {
      native.openBrowser(jumpUrl);
    }
  };

  const renderContent = () => {
    if (variant === 'consumable') {
      return (
        <>
          <div className={styles.modalTitle} style={{ marginBottom: 16 }}>
            {$t((v) => v.CutoutQuotaNotice)}
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>{$t((v) => v.RenewalMemberNote)}</div>
            <div className={styles.modalDescValue}>{$t((v) => v.AutoDeliveryOnPurchase)}</div>
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>{$t((v) => v.NonRenewalMemberNote)}</div>
            <div className={styles.modalDescValue}>{$t((v) => v.AutoDeliveryOnTransaction)}</div>
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>{$t((v) => v.CutoutQuotaLabel)}</div>
            <div className={styles.modalDescValue}>{$t((v) => v.CutoutQuotaDesc)}</div>
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>{$t((v) => v.CutoutQuotaExpiryLabel)}</div>
            <div className={styles.modalDescValue}>{$t((v) => v.CutoutQuotaExpiryDesc)}</div>
          </div>
          <div className={styles.modalDescRow} style={{ flexDirection: 'row' }}>
            <div className={styles.modalDescLabel}>{$t((v) => v.TrialAddressLabel)}</div>
            <div
              className={classnames(styles.modalDescValue, styles.link)}
              onClick={() => handleJump('https://www.designkit.cn/cutout')}
            >
              www.designkit.cn/cutout
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <div className={styles.modalTitle}>{$t((v) => v.ServiceNotice)}</div>
        <div className={styles.modalDesc}>{$t((v) => v.AutoRenewNote1)}</div>
        <div className={styles.modalDesc}>{$t((v) => v.AutoRenewNote2)}</div>
        <div className={styles.modalDesc}>{$t((v) => v.AutoRenewNote3)}</div>
        <div className={styles.modalDesc}>
          {$t((v) => v.AutoRenewNote4)}
          <a onClick={() => handleJump(WECHAT_CANCEL_GUIDE_URL)}>{WECHAT_CANCEL_GUIDE_URL}</a>
        </div>
        <div className={styles.modalDesc}>{$t((v) => v.AutoRenewNote5)}</div>
      </>
    );
  };

  return (
    <Modal
      visible={visible}
      wrapStyle={{ borderRadius: getIncomeSource() !== 'MTXX-WEB' ? 0 : '0 12px 12px 0' }}
      style={{ width: 400, height: 'auto', backgroundColor: '#181A1C' }}
      onClose={onClose}
    >
      {renderContent()}
      <div className={styles.btn} onClick={onClose}>
        {$t((v) => v.Button_Ok)}
      </div>
    </Modal>
  );
};

export default React.memo(ServiceNoticeModal);
